// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");

function ifTrue(element, condition) {
  if (condition) {
    return element;
  } else {
    return null;
  }
}

function ifFalse(element, condition) {
  if (condition) {
    return null;
  } else {
    return element;
  }
}

function fromOption(opt, f) {
  return Stdlib_Option.getOr(Stdlib_Option.map(opt, f), null);
}

exports.ifTrue = ifTrue;
exports.ifFalse = ifFalse;
exports.fromOption = fromOption;
/* No side effect */
